import { render, staticRenderFns } from "./add-quota.vue?vue&type=template&id=270d90fc&scoped=true"
import script from "./add-quota.vue?vue&type=script&lang=js"
export * from "./add-quota.vue?vue&type=script&lang=js"
import style0 from "./add-quota.vue?vue&type=style&index=0&id=270d90fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d90fc",
  null
  
)

export default component.exports